module.exports = __webpack_public_path__ + "img/gradient-7.24f974fc.png";